module.exports = __webpack_public_path__ + "img/live-movie-play.81d22bfb.png";